import React, { PureComponent, Fragment } from "react";

// import ReactEcharts from "echarts-for-react";
import ReactEcharts from "echarts-for-react";

export default class BiaxialLineChart extends PureComponent {
  constructor(props) {
    super(props);

    var chartData = this.parseData(this.props.data);
    var isKeezle = this.props.data ? this.props.data.id == 'keezle' : false;
    this.state = {
      yearList: chartData.yearList,
      newValueList: chartData.newValueList,
      renewValueList: chartData.renewValueList,
      apOldValueList: chartData.apOldValueList,
      renewRateValueList: chartData.renewRateValueList,
      totalValueList: chartData.totalValueList,
      totalTopValueList: chartData.totalTopValueList,
      totalBottomValueList: chartData.totalBottomValueList,
      sumValueList: Array.from(chartData.newValueList, () => 0),
      unselectedList: [],

      maxValue: chartData.maxValue,
      isKeezle: isKeezle
    };
  }

  componentWillReceiveProps = (nextProps) => {
    var chartData = this.parseData(nextProps.data);
    var isKeezle = nextProps.data ? nextProps.data.id == 'keezle' : false;

    this.setState({
      yearList: chartData.yearList,
      newValueList: chartData.newValueList,
      renewValueList: chartData.renewValueList,
      apOldValueList: chartData.apOldValueList,
      renewRateValueList: chartData.renewRateValueList,
      totalValueList: chartData.totalValueList,
      totalTopValueList: chartData.totalTopValueList,
      totalBottomValueList: chartData.totalBottomValueList,
      sumValueList: Array.from(chartData.newValueList, () => 0),

      maxValue: chartData.maxValue,
      isKeezle: isKeezle
    });
  };

  containsList = (element) => {
    for (var i = 0; i < this.state.unselectedList.length; i++) {
      if (this.state.unselectedList[i] === element) {
        return i;
      }
    }
    return -1;
  };

  parseData = (chartData) => {
    var isKeezle = this.props.data ? this.props.data.id == 'keezle' : false;
    var maxValue = 20;

    var yearList = [];
    var newValueList = [];
    var renewValueList = [];
    var apOldValueList = [];
    var renewRateValueList = [];
    var totalValueList = [];

    var totalTopValueList = [];
    var totalBottomValueList = [];

    for (const year in chartData.stat) {
      const stat = chartData.stat[year];
      yearList.push(stat.year);
      newValueList.push(stat.countApNew);
      renewValueList.push(stat.countApRe);
      apOldValueList.push(stat.countApOld || 0);
      renewRateValueList.push(stat.rateRe);

      var topVal = stat.total;
      // if (Number(stat) > 2018) topVal = topVal / 2;

      totalValueList.push(topVal);
      var bottomVal = stat.countApNew + stat.countApRe + (stat.countApOld || 0);

      if (bottomVal > topVal) {
        var tmp = topVal;
        topVal = bottomVal;
        bottomVal = tmp;
      }
      topVal = topVal - bottomVal;
      totalTopValueList.push(topVal);
      totalBottomValueList.push(bottomVal);

      if (maxValue < stat.total) {
        maxValue = stat.total;
      }
    }

    maxValue = maxValue > 100 ? Math.ceil(maxValue / 100) * 100 + 10 : Math.ceil(maxValue / 10) * 10;

    return {
      yearList: yearList,
      newValueList: newValueList,
      renewValueList: renewValueList,
      apOldValueList: apOldValueList,
      renewRateValueList: renewRateValueList,
      totalValueList: totalValueList,
      totalTopValueList: totalTopValueList,
      totalBottomValueList: totalBottomValueList,
      maxValue: maxValue,
    };
  };

  onChartLegendSelectChanged(param, echart) {
    alert("onLegendSelect: " + param + echart);
  }

  _onEvent = {
    click: (params) => {
      this.props.yearChangeFn(params.name);
    },
    // legendselectchanged: (params, chart) => {
    //   if (params.name == "신규" || params.name == "재계약") {
    //     var isSelected = params.selected[params.name];
    //     var index = this.containsList(params.name);
    //     if (isSelected) {
    //       if (index != -1) {
    //         this.state.unselectedList.splice(index, 1);
    //       }
    //     } else {
    //       if (index == -1) {
    //         this.state.unselectedList.push(params.name);
    //       }
    //     }

    //     chart.setOption({ animation: true });
    //   }
    // },
  };

  _onAction = {
    type: "highlight",
    name: this.props.year,
  };

  onChartReadyCallback = (e) => {
    if (e) this.state.EchartInstance = e.getEchartsInstance();

    if (this.state.EchartInstance) {
      var dataIndex = 0;
      this.state.yearList.forEach((year, idx) => {
        if (this.props.year == year) dataIndex = idx;
      });

      // this.state.EchartInstance._api.dispatchAction({type : 'highlight',dataIndex : dataIndex})
    }
  };

  render() {
    const {isKeezle} = this.state;
    const legend = isKeezle ? ["계약 유지", "신규", "재계약", "재계약률", "영업종료기준"] : ["신규", "재계약", "재계약률", "영업종료기준"];
    const titleYAxis0 = isKeezle ? "계약(건)" : "클래스(건)";
    let series = [];
    if(isKeezle) {
      series.push(
        {
          name: "계약 유지",
          type: "bar",
          stack: "one",
          data: this.state.apOldValueList,
          label: {
            show: true,
            position: "insideTop",
            formatter: (param) => {
              return param.value.toLocaleString();
            },
          },
        });
    }
    series = series.concat([
      {
        name: "신규",
        type: "bar",
        stack: "one",
        data: this.state.newValueList,
        label: {
          show: true,
          position: "insideTop",
          formatter: (param) => {
            return param.value.toLocaleString();
          },
        },
      },
      {
        name: "재계약",
        type: "bar",
        stack: "one",
        data: this.state.renewValueList,
        label: {
          show: true,
          position: "insideTop",
          formatter: (param) => {
            return param.value.toLocaleString();
          },
        },
      },
      {
        name: "Sum",
        type: "bar",
        stack: "one",
        data: this.state.sumValueList,
        color: "#00fff",
        label: {
          show: true,
          position: "top",
          formatter: (params) => {
            let total = 0;
            option.series.forEach((serie) => {
              if (
                serie.stack == "one" &&
                this.containsList(serie.name) == -1
              ) {
                total += serie.data[params.dataIndex];
              }
            });
            return total.toLocaleString();
          },
        },
      },
      {
        name: "재계약률",
        type: "line",
        yAxisIndex: 1,
        data: this.state.renewRateValueList,
      },
      {
        name: "영업종료기준",
        type: "bar",
        barGap: "-100%",
        itemStyle: {
          // opacity : 0  ,
          color: "none",
          borderWidth: 2,
          borderColor: "auto",
          borderType: "dashed",
        },
        z: 10,
        yAxisIndex: 0,
        label: {
          show: false,
          position: "top",
          color: "#000000",
        },
        data: this.state.totalValueList,
      },
      /*{
              name: '영업종료기준1',
              type: 'bar',
              barGap : '-100%',
              stack : 'two',
              itemStyle : {
                // opacity : 0  ,
                color : 'none',
                borderWidth : 0
              },
              z : 12,
              data: this.state.totalBottomValueList
          },
          {
              name: '영업종료기준2',
              type: 'bar',
              barGap : '-100%',
              stack : 'two',
              itemStyle : {
                color : 'none',
                borderWidth : 1,
                borderColor : (params) => {
                  let total = 0;
                  option.series.forEach(serie => {
                    if (serie.stack == 'one' && this.containsList(serie.name) == -1) {
                        total += serie.data[params.dataIndex];
                    }
                  })
                  console.log(total + " <= "+ params.data + " = " + total <= params.data);
                  if(total <= params.data) {
                    return "#000000"
                  } else {
                    return "#FFFFFF"
                  }
                  
                },
                borderType : "dashed"
              },
              // z : 12,
              data: this.state.totalTopValueList
          }*/
    ]);
    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        formatter: (params, chart, test) => {
          var tooltipHtml = "";

          for(var i = 0; i < params.length; i++) {
            var e = params[i];
            if (!tooltipHtml) tooltipHtml += e.name + "<br/>";

            if (e.seriesName !== "Sum") {
              tooltipHtml +=
                e.marker.replace("none", "#FFFFFF") +
                e.seriesName +
                " : " +
                e.value.toLocaleString();
              if (e.componentSubType === "line" && e.seriesName == "재계약률")
                tooltipHtml += " %";

              tooltipHtml += " <br/>";
            }
          }
          return tooltipHtml;
        },
      },
      legend: {
        data: legend,
      },
      xAxis: [
        {
          type: "category",
          data: this.state.yearList,
          axisPointer: {
            type: "shadow",
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: titleYAxis0,
          min: 0,
          axisLabel: {
            formatter: (param) => {
              return param.toLocaleString();
            },
          },
        },
        {
          type: "value",
          name: "재계약율(%)",
          min: 0,
          max: 100,
          interval: 20,
          axisLabel: {
            formatter: "{value} %",
          },
        },
      ],
      series: series,
    };

    return (
      <ReactEcharts
        theme="macarons"
        ref={(e) => {
          this.onChartReadyCallback(e);
        }}
        option={option}
        onEvents={this._onEvent}
        onChartReady={this.onChartReadyCallback()}
      />
    );
  }
}
